export default "__VITE_ASSET__B86G4ELd__"